// Input header
export const useScrollStore = defineStore('scroll', () => {
  const isScrolledInput = ref(false)
  const isHalfScrolled = ref(false)
  const isScrolled = ref(false)

  function checkScrollInput() {
    const w =
      typeof globalThis !== 'undefined'
        ? (globalThis as unknown as ScrollWindowMetrics)
        : undefined
    if (!w || typeof w.scrollY !== 'number') return
    isScrolled.value = w.scrollY > 20

    const height = w.innerHeight - (w.innerHeight / 2)
    isScrolledInput.value = w.scrollY > (height)

    const halfHeight = w.innerHeight - (w.innerHeight / 1.25)
    isHalfScrolled.value = w.scrollY > halfHeight
  }

  return { isScrolledInput, checkScrollInput, isHalfScrolled, isScrolled }
})